/* eslint-disable no-shadow */
import React, {useEffect, useState} from 'react';
import {
    Image,
    TextInput,
    TouchableOpacity,
    View,
    TouchableWithoutFeedback, Platform,
} from 'react-native';
//import PathFile from '../../../../../assets/PathFile';
import type {CTextInput} from './model';
import {styles} from './styles';
import HMIcon from "../../../../HMIcon";
import Colors from "../../../../../tools/Colors";
import {moderateScale} from "../../../../../tools/Scaling";
import HMTextInput from '../../../../HMTextInput';

//const ic_close = (PathFile.image.logo);

const defaultProps = {
    style: {},
    value: '',
    showIcon: true,
    currency: false,
    numeric: false,
};

const TextInputComponent: CTextInput = (props) => {
    const {
        fontFamily,
        style,
        value,
        placeholderTextColor = '#000',
        placeholder = '',
        showIcon,
        inputStyle,
        iconStyle,
        onChangeText = (_value: string) => {
        },
        renderLeftIcon,
        renderRightIcon,
    } = props;

    const [text, setText] = useState<string>('');

    useEffect(() => {
        if (value) {
            setText(value);
        }
    }, [value]);

    const onChange = (text: string) => {
        setText(text);
        onChangeText(text);
    };

    const _renderRightIcon = () => {
        if (showIcon) {
            if (renderRightIcon) {
                return renderRightIcon();
            }
            if (text.length > 0) {
                return (
                    <TouchableOpacity onPress={() => onChange('')}>
                        <HMIcon
                            name={"closecircleo"}
                            type={"AntDesign"}
                            style={{
                                alignSelf: 'center',
                                // width: moderateScale(14),
                                color: Colors.colorDark,
                                marginHorizontal: moderateScale(5),
                                fontSize: Platform.OS === 'ios' ? moderateScale(28) : moderateScale(26),
                                textAlign: 'center'
                            }}/>
                    </TouchableOpacity>
                );
            }
            return null;
        }
        return null;
    };

    const font = () => {
        if (fontFamily) {
            return {
                fontFamily: fontFamily,
            };
        } else {
            return {};
        }
    };

    return (
        <TouchableWithoutFeedback>
            <View style={[style]}>
                <View style={styles.textInput}>
                    {renderLeftIcon?.()}
                    <HMTextInput
                        {...props}
                        style={[styles.input, inputStyle, font(),]}
                        value={text}
                        placeholder={placeholder}
                        placeholderTextColor={placeholderTextColor}
                        onChangeText={onChange}
                        styleRoot={{flex: 1}}
                    />
                    {_renderRightIcon()}
                </View>
            </View>
        </TouchableWithoutFeedback>
    );
};

TextInputComponent.defaultProps = defaultProps;

export default TextInputComponent;
